export const COORDINATES_DEFAULT = {
    latitude: 46.7,
    longitude: 2.213749,
    zoom: 7
};

export const TYPE_BIEN_ICONS = {
    
}